import type { AxShape } from "../bridge/selection";
import { useBusEmitterListener } from "../bridge";
import { addSelectedShape } from "../interop/dotnetExports/connector";

const requestShapeTriggeredEvent = Symbol("bridge:requestShapeTriggered");

const {
  emitter: requestShapeTriggeredFn,
  listener: onRequestShapeTriggeredFn,
} = useBusEmitterListener<{ x: number; y: number }>(requestShapeTriggeredEvent);

export function requestShapeTriggered(x: number, y: number) {
  requestShapeTriggeredFn({ x, y });
}
export const onRequestShapeTriggered = onRequestShapeTriggeredFn;

export function selectShape(target: AxShape) {
  addSelectedShape(target);
}
